import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SamlRequest } from "src/app/model/samltoken";
import { environment } from 'src/environments/environment';
import { AuthService } from "../_services/auth.service";
import { ClaveService } from "../_services/clave.service";
import { ConfirmarCorreoService } from "../_services/confirmar-correo.service";
import { NotificationService } from "../_services/notification.service";
import { TokenStorageService } from "../_services/token-storage.service";
import { UrlService } from "../_services/urlService";
import { UserService } from "../_services/user.service";
import { ClientLoaderService } from "../core/util/client-loader.service";
import { RaizComponent } from "../raiz/raiz.component";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  form: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
    password: new FormControl("", [Validators.required, Validators.minLength(6)]),
    totpkey: new FormControl(""),
  });

  form2: FormGroup = new FormGroup({
    totpkey: new FormControl("", [Validators.required, Validators.minLength(6)])
  });

  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = "";
  midata: string[] = [];
  tfaFlag: boolean = false;
  tfa: string = null;
  userRoles: any = [];
  submitted = false;
  loading = false;
  returnUrl: string;
  errorTfa: boolean;
  check2fa: boolean = false;
  errorQR: boolean;
  tfActivated: boolean;
  resetQR: boolean = false;
  resetedQR: boolean = false;
  qr: { secretURL?: string; secret?: string; result?: string } | null = null;
  loadingQr = false;
  environment: string = environment.environment;
  previousUrl: string = '';
  correoNoConfirmado: boolean = false;
  loginType: string = 'both';
  vpnActiva = false;

  constructor(
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private urlService: UrlService,
    private _notificationSvc: NotificationService,
    private raiz: RaizComponent,
    private _confirmarCorreo: ConfirmarCorreoService,
    private _claveservice: ClaveService,
    private clientLoader: ClientLoaderService,
    private translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.loginType = this.clientLoader.getLoginType();
    this.vpnActiva = this.clientLoader.isVpnActiva();
    this.returnUrl = this.route.snapshot.queryParamMap.get('route') || 'admin';
    this.checkPrevious();
    if (this.tokenStorage.getToken() && this.tokenStorage.isPending2FAEnrollment()) {
      this.resetearQR();
      return;
    }
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.midata = this.tokenStorage.getUser();
    }
  }

  checkPrevious() {
    this.previousUrl = this.urlService.getPreviousUrl();
  }



  onSubmit(): any {
    this.submitted = true;

    if (this.form.get('email').hasError('pattern')) {
      this._notificationSvc.warning(this.translate.instant('COMMON.INFO'), this.translate.instant('LOGIN.MSG.EMAIL_INVALID'), 5000);
      return false;
    }
    if (this.form.get('password').hasError('minlength')) {
      this._notificationSvc.warning(this.translate.instant('COMMON.INFO'), this.translate.instant('LOGIN.MSG.PASSWORD_MIN'), 5000);
      return false;
    }
    if (!this.form.valid) {
      this._notificationSvc.warning(this.translate.instant('COMMON.INFO'), this.translate.instant('LOGIN.MSG.FILL_FIELDS'), 5000);
    } else {
      this.authService.login(this.form.controls['email'].value, this.form.controls['password'].value, this.form.controls['totpkey'].value).subscribe({
        next: async (data) => {

          if (data['2faEnabled'] === "true" && data['tfa'] === "disabled") {
            this.tokenStorage.saveToken(data.accessToken);
            this.tokenStorage.setPending2FAEnrollment(true);
            this.resetearQR();
          } else if (data['pending2FAEnrollment'] === "true" && data['tfa'] === "disabled") {
            this.tokenStorage.saveToken(data.accessToken);
            this.tokenStorage.setPending2FAEnrollment(true);
            this.resetearQR();
          } else if (data['tfa'] === "disabled") {
            this.tokenStorage.saveToken(data.accessToken);
            this.tokenStorage.setPending2FAEnrollment(false);
            this.loginTfaDisabled();
          } else if (data['tfa'] !== "disabled") {
            this.form.controls['totpkey'].addValidators([Validators.required, Validators.minLength(6)])
            this.submitted = false;
            this.tfaFlag = true;
          }
        },
        error: (error) => {
          console.error(error);

          if (error.error.status == 650) {
            this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('LOGIN.MSG.INVALID_CREDENTIALS'), 50000);
          }
          else if (error.error.status == 651) {
            this._notificationSvc.errorRedir(this.translate.instant('COMMON.ERROR'), this.translate.instant('LOGIN.MSG.USER_DEACTIVATED'), 50000, this.translate.instant('LOGIN.MSG.REACTIVATE_HINT'), '../forgot-password');
          }
          // if(error.error.status == 642){
          //   this._confirmarCorreo.getEmailConfirmacion(this.form.controls['email'].value).subscribe({
          //     next: (data) => {
          //       this.router.navigate(['confirmar-correo', 'correo-no-confirmado', data.token]);

          //     }
          //   })
          // }
          this.isLoginFailed = true;
        },
      });
    }
  }

  logout(): void {
    this.cancelarEnrolamiento2FA();
  }

  /** Cierra sesión y vuelve al formulario de login sin reabrir el QR. */
  cancelarEnrolamiento2FA(): void {
    this.tokenStorage.setPending2FAEnrollment(false);
    this.tokenStorage.signOut();
    this.authService.updateAuthStatus(false);
    this.resetQR = false;
    this.resetedQR = false;
    this.tfaFlag = false;
    this.qr = null;
    this.loadingQr = false;
    this.errorQR = false;
    this.submitted = false;
    this.isLoggedIn = false;
    this.isLoginFailed = false;
    this.form2.reset();
  }

  private irAlAdminTrasLogin(): void {
    if (this.environment === 'novotaxi') {
      this.router.navigate(['/admin-novotaxi']);
      return;
    }
    this.router.navigate(['/admin']);
  }

  loginTfaEnabled(): any {
    this.submitted = true;

    if (this.form.get('totpkey').hasError('minlength')) {
      this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('LOGIN.MSG.CODE_MIN'), 5000);
      return false;
    }

    if (!this.form.valid) {
      this._notificationSvc.warning(this.translate.instant('COMMON.INFO'), this.translate.instant('LOGIN.MSG.FILL_FIELDS'), 5000);
      return false;
    }
    this.authService.login(this.form.controls['email'].value, this.form.controls['password'].value, this.form.controls['totpkey'].value).subscribe({
      next: (dataTotpkey) => {
        if (dataTotpkey.codigoError !== "INVALID_2FA") {
          this.tokenStorage.saveToken(dataTotpkey.accessToken);
          this.tokenStorage.setPending2FAEnrollment(false);
          this.authService.updateAuthStatus(true);
          this.userService.getCurrentUserFromServer().subscribe({
            next: (data) => {
              this.tokenStorage.setUser(data.Usuario, data.usuarioRepresenta);
              this.raiz.reloadHeader = !this.raiz.reloadHeader;
              if (this.environment == 'novotaxi') {
                this.router.navigateByUrl('/admin-novotaxi').then(() => {
                  this.router.navigate(['admin-novotaxi']);
                });
              } else {
                this.router.navigateByUrl(this.returnUrl);
              }
            },
            error: (error) => {
              //TODO error
            }
          })
        } else {
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('LOGIN.MSG.CODE_INVALID'), 5000);
          this.form.controls['totpkey'].setErrors({ 'incorrect': true });
        }
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.isLoginFailed = true;
      },
    })
  }

  loginTfaDisabled(): any {
    this.isLoggedIn = true;
    this.isLoginFailed = false;
    this.authService.updateAuthStatus(true);
    this.userService.getCurrentUserFromServer().subscribe({
      next: (data) => {
        this.tokenStorage.setUser(data.Usuario, data.usuarioRepresenta);
        this.raiz.reloadHeader = !this.raiz.reloadHeader;
        if (this.environment == 'novotaxi') {
          this.router.navigateByUrl('/admin-novotaxi').then(() => {
            this.router.navigate(['admin-novotaxi']);
          });
        } else {
          this.router.navigateByUrl(this.returnUrl);
        }
      },
      error: (error) => {

      }
    })

  }

  resetearQR(): void {
    this.resetQR = true;
    this.qr = null;
    this.errorQR = false;
    this.pedirQR();
  }

  pedirQR(): void {
    this.submitted = false;
    this.loadingQr = true;
    this.authService.pedirQr().subscribe({
      next: (data) => {
        this.qr = data;
        this.loadingQr = false;
      },
      error: (err) => {
        this.loadingQr = false;
        this.errorQR = true;
        console.error(err);
      }
    });
  }

  guardarQR(): any {
    this.submitted = true;

    if (this.form2.get('totpkey').hasError('minlength')) {
      this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('LOGIN.MSG.CODE_MIN'), 5000);
      return false;
    }

    if (!this.form2.valid) {
      this._notificationSvc.warning(this.translate.instant('COMMON.ERROR'), this.translate.instant('LOGIN.MSG.MISSING_FIELDS'), 50000);
    } else {
      this.authService.guardarQR(this.qr!.secret!, this.form2.get('totpkey').value?.toString().trim()).subscribe({
        next: (data) => {
          if (data?.result === 'success') {
            this.tokenStorage.setPending2FAEnrollment(false);
            this.authService.updateAuthStatus(true);
            this.resetQR = false;
            this.resetedQR = false;
            this.errorQR = false;
            this.userService.getCurrentUserFromServer().subscribe({
              next: (userData) => {
                this.tokenStorage.setUser(userData.Usuario, userData.usuarioRepresenta);
                this.raiz.reloadHeader = !this.raiz.reloadHeader;
                this.irAlAdminTrasLogin();
              },
              error: () => {
                this.irAlAdminTrasLogin();
              }
            });
          } else {
            this.qr = data;
            this.form2.reset();
            this.errorQR = true;
          }
        },
        error: (error) => {
          if (error.error?.secret) {
            this.qr = error.error;
          }
          this.form2.reset();
          this.errorQR = true;
          if (error.error?.codigo == 637) {
            this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('LOGIN.MSG.CODE_WRONG'), 5000);
          }
        }
      });
    }
  }
  redireccion(): void {
    this._claveservice.getSamlRequest().subscribe({
      next: async (data: SamlRequest) => {
        this.post(data.nodeService, {
          SAMLRequest: data.SamlRequest,
          RelayState: data.RelayState,
        });
      },
    });
  }
  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
}

